let mProjectContentFilter:any;
export function initProjectContentFilter(db){
    mProjectContentFilter = db.table('projectContentFilter');
}

export function getProjectContentFilter(szId){
    if (!szId)return new Promise(resolve => {
        resolve(null);
    });
    return mProjectContentFilter.get(szId);
}

export function updateProjectContentFilterSort(contentFilterSort){
    mProjectContentFilter.put(contentFilterSort)
}

/**
 * 更新可见的元素类型
 * @param szId
 * @param arrayLibraryTypes
 */
export async function updateProjectContentFilter(szId,arrayLibraryTypes){
    let projectContent = await getProjectContentFilter(szId);
    if (projectContent){
        projectContent.arrayLibraryTypes = arrayLibraryTypes;

    }else{
        projectContent = {
            id:szId,
            arrayLibraryTypes:arrayLibraryTypes
        }
    }
    await mProjectContentFilter.put(projectContent)
}

/**
 * 更新排序方式
 * @param szId
 * @param szSortBy
 * @param szOrderBy
 */
export async function updateProjectContentSort(szId,szSortBy,szOrderBy){
    let projectContent = await getProjectContentFilter(szId);
    if (projectContent){
        if (szSortBy){
            projectContent.sortBy = szSortBy;
        }
        if (szOrderBy){
            projectContent.orderBy = szOrderBy;
        }

        if (!projectContent.sortBy){
            projectContent.sortBy = 'sort by createDate';//默认排序.
        }
    }else{
        projectContent = {
            id:szId,
            sortBy:szSortBy,
            orderBy:szOrderBy
        }
    }
    await mProjectContentFilter.put(projectContent);
    return projectContent;
}